

import React from "react";
import { Swiper } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.css";
import { useMediaQuery } from "react-responsive";
import { Wrapper } from "../styles";

export const Carousel = ({ t, children }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <>
            <Swiper
                slidesPerView={isMobile ? 1 : 2}
                slidesPerGroup={1}
                loop={true}
                loopFillGroupWithBlank={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}

            >
                <Wrapper type="container">
                    {children}
                </Wrapper>
            </Swiper>
        </>
    );
}
